module.exports = __webpack_public_path__ + "static/media/scotiabanck-100px.772bfa6d.svg";